module.exports = __webpack_public_path__ + "img/exclamation-2.8961f55e.svg";